"use client"

import { useState } from "react"
import AppImage from "../ui/AppImage"
import Link from "next/link"
import LoginModal from "../screens/auth/LoginModal"
import { ThemeToggle } from "./ThemeToggle"

type HeaderProps = {
  /** overlay = white logo over heroes; light = black logo on plain pages */
  variant?: "overlay" | "light"
}

export default function Header({ variant = "overlay" }: HeaderProps) {
  const [loginOpen, setLoginOpen] = useState(false)
  const isLight = variant === "light"

  return (
    <div
      className={
        isLight
          ? "relative z-50 flex w-full items-center justify-between border-b border-border/60 bg-background px-4 py-2 lg:px-20"
          : "absolute top-2 z-50 flex w-full items-center justify-between px-4 lg:px-20"
      }
    >
      <div className="p-4">
        <Link href="/">
          <AppImage
            src={isLight ? "/logos/MEVOLY_black.png" : "/logos/MEVOLY_white1.png"}
            alt="Mevoly Logo"
            className="w-56 lg:w-44 h-auto object-cover"
            priority
          />
        </Link>
      </div>
      <div className="flex gap-4">
        <LoginModal
          open={loginOpen}
          onOpenChange={setLoginOpen}
          triggerColor={isLight ? "brand" : "white"}
        />
        <ThemeToggle />
      </div>
    </div>
  )
}
